import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export enum AuditActionEnum
{
     None = 0,
     Insert,
     Update,
     Delete
}


export enum AuditActionSubTypeEnum
{
     None = 0,
     //[Description("Control (WriteDown)")]
     ControlWriteDown = 1,
     //[Description("Manual Entry")]
     ManualEntry = 2,
     //[Description("Well Configuration")]
     WellConfiguration = 3,
     //[Description("Comm Endpoint Address")]
     CommEndpointAddress = 4
}


export interface IAuditTrail {
    id: number;
    objectType: eLynxObjectTypeEnum;
    objectID: number;
    objectName: string;
    action: AuditActionEnum;
    actionSubType?: AuditActionSubTypeEnum;
    userLogin: string;
    userID: number;
    oldValue: string;
    newValue: string;
    parentObjectType?: eLynxObjectTypeEnum;
    parentObjectID?: number;
    //parentObjectName?: string;
    parentName?: string;
    timestamp: Date;
    additionalInfo?: string;
    additionalID?: number;
    impersonatedUserID?: number;
    impersonatedUserLogin?: string;

    userIPAddress?: string;

}